// import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "@/app/index";
import { initOpenReplay } from "@/app/openreplay/init-openreplay";

initOpenReplay();

createRoot(document.getElementById("root")!).render(
  // <StrictMode>
  <App />,
  // </StrictMode>
);
